module.exports = __webpack_public_path__ + "static/media/VIDEO-COUNT-5.14b4e771.png";